import { OwlDateTimeIntl } from "ng-pick-datetime";
import { TranslateService } from "@ngx-translate/core";
import { Inject } from "@angular/core";

export class LocalizedIntl extends OwlDateTimeIntl {
    constructor(@Inject(TranslateService) private _translate: TranslateService) {
        super();
    }

  /** A label for the cancel button */
  cancelBtnLabel = this._translate.instant('date.cancel');

  /** A label for the set button */
    setBtnLabel = this._translate.instant('date.set');
};